module.exports = __webpack_public_path__ + "static/media/cs-bg.ab34894a.jpg";